exports = module.exports = require("../../../../../../legacy/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".coins-amount[data-v-19e1c3e9] {\n  font-weight: bolder;\n  color: #5f6261;\n}\n.coins-amount img[data-v-19e1c3e9] {\n  margin-left: 4px;\n  width: 14px;\n  height: 14px;\n}", ""]);

// exports
